const bricsa = {
  FORMS: [],
  CSS: {
    id: '64f61eb4810761da869bc6f0',
    name: 'bricsa',
    avatar: {
      name: 'Bricsa',
      header: 'https://chatbotqa.gatblac.com/static/avatar/bricsa/avatar1/avatar_close.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/bricsa/avatar1/avatar_new.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/bricsa/avatar1/avatar_open.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/bricsa/avatar1/avatar_close.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#FFA438',
        borderColor: '#FFA438'
      }
    }
  }
}

export default bricsa
